import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles, MonitorSmartphone } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
export function HeroVariant81() {
  const {
    t
  } = useLanguage();
  const {
    formattedPrice
  } = usePricing();
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-[var(--bg-primary)]" data-id="element-1019">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full relative z-10" data-id="element-1020">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-1021">
          {/* Left Column: Editorial Typography */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="max-w-2xl" data-id="element-1022">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[var(--text-primary)] leading-[1.2] mb-8 uppercase" data-id="element-1023">
              Создаем{' '}
              <span className="inline-flex items-center justify-center w-14 h-10 sm:w-16 sm:h-12 mx-2 bg-[var(--accent)] text-white rounded-full align-middle rotate-[-5deg]" data-id="element-1024">
                <Sparkles className="w-6 h-6 sm:w-8 sm:h-8" data-id="element-1025" />
              </span>{' '}
              уникальные сайты для клиентов,{' '}
              <span className="inline-block w-16 h-10 sm:w-20 sm:h-12 mx-2 rounded-full overflow-hidden align-middle border-2 border-[var(--border)]" data-id="element-1026">
                <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=100&q=80" alt="Team" className="w-full h-full object-cover" data-id="element-1027" />
              </span>{' '}
              нужно оплачивать только за обслуживание{' '}
              <span className="inline-flex items-center justify-center w-14 h-10 sm:w-16 sm:h-12 mx-2 bg-[var(--bg-secondary)] border border-[var(--border)] text-[var(--text-primary)] rounded-full align-middle rotate-[5deg]" data-id="element-1028">
                <MonitorSmartphone className="w-6 h-6 sm:w-8 sm:h-8" data-id="element-1029" />
              </span>{' '}
              всего лишь{' '}
              <span className="inline-flex items-center justify-center px-6 py-2 mt-2 bg-[var(--accent)] text-white rounded-full text-3xl sm:text-4xl align-middle" data-id="element-1030">
                {formattedPrice}
                <span className="text-xl sm:text-2xl ml-1" data-id="element-1031">/мес</span>
              </span>
            </h1>

            <div className="flex flex-col sm:flex-row gap-4 mt-10" data-id="element-1032">
              <button onClick={scrollToContact} className="inline-flex items-center justify-center px-8 py-4 text-base font-medium rounded-xl text-white bg-[var(--accent)] hover:bg-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1" data-id="element-1033">
                {t('hero.cta')}
                <ArrowRight className="ml-2 w-5 h-5" data-id="element-1034" />
              </button>
            </div>
          </motion.div>

          {/* Right Column: Clean Video */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative lg:h-[800px] rounded-3xl overflow-hidden border border-[var(--border)] shadow-2xl" data-id="element-1035">
            <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover" data-id="element-1036">
              <source src="https://cdn.coverr.co/videos/coverr-working-in-a-modern-office-2621/1080p.mp4" type="video/mp4" data-id="element-1037" />
            </video>
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" data-id="element-1038"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}